<template>
  <div>
    <!-- Tabla de chapters-->
    <transition
      name="custom-classes-transition"
      enter-active-class="animated fadeInUp"
      leave-active-class="animated fadeOutDown"
    >

    <div class="panel">
      <div v-if="isLoading" class="my-4 text-center">
        <scale-loader></scale-loader>
      </div>
      <div v-else>
        <div class="flex flex-wrap w-full mt-4">
        <section class="w-full">
          <b-table v-if="!isLoading"
            icon-pack="fas"
            :data="pictograms"
            :paginated="isPaginated"
            :per-page="perPage"
            :bordered="true"
            :current-page.sync="currentPage"
            :pagination-simple="isPaginationSimple"
            :default-sort-direction="defaultSortDirection"
            :checkable="false"
            checkbox-position="left"
            :checkbox-type="'is-success'"
            :checked-rows.sync="checkedRows"
            @check="handleCheck"
            :row-class="(row) => row.id === highlightedRowId ? 'row-highlight' : ''">
            <template>
              <!-- <b-table-column field="thumbnail" cell-class="w-6 vertical-center" sortable>
                <template v-slot:header="">{{ $t('thumbnail') }}</template>
                <template v-slot="props">
                  <div class="flex flex-wrap justify-center">
                    <img
                      :src="props.row.file.thumbnail"
                      class="p-1 bg-white border rounded"
                      :alt="props.row.description"
                      onerror="this.src='https://epc-tracker-assets.s3.eu-west-3.amazonaws.com/public/thumb.jpeg'"
                    />
                  </div>
                </template>
              </b-table-column> -->

              <b-table-column field="code" cell-class="vertical-center" sortable :visible="false">
                <template v-slot:header="">{{ $t('code') }}</template>
                <template v-slot="props">{{ props.row.code }}</template>
              </b-table-column>

              <b-table-column field="name" cell-class="vertical-center" sortable>
                <template v-slot:header="">{{ $t('name') }} / {{ $t('description') }}</template>
                <template v-slot="props">{{ props.row.name }}<br> {{ props.row.description }}</template>
              </b-table-column>

              <b-table-column field="thumbnail" cell-class="vertical-center" width="120">
                <template v-slot:header="">{{ $t('preview') }}</template>
                <template v-slot="props">
                  <div class="flex justify-center">
                    <img
                      :src="props.row.screenshot"
                      class="pictogram-preview"
                      :alt="props.row.name"
                      onerror="this.src='https://epc-tracker-assets.s3.eu-west-3.amazonaws.com/public/thumb.jpeg'"
                    />
                  </div>
                </template>
              </b-table-column>

              <b-table-column field="type" cell-class="vertical-center" sortable>
                <template v-slot:header="">{{ $t('type') }}</template>
                <template v-slot="props">{{ $t(props.row.type ? props.row.type : 'mechanical_installation')  }}</template>
              </b-table-column>

              <b-table-column field="activity_progress" cell-class="vertical-center" sortable numeric width="100">
                <template v-slot:header="">{{ $t('progress') }}</template>
                <template v-slot="props">
                  {{ props.row.activity_progress }} %
                </template>
              </b-table-column>

              <b-table-column field="actions" cell-class="vertical-center" width=100>
                <template v-slot:header="">{{ $t('actions') }}</template>
                <template v-slot="props">
                  <div class="flex items-center justify-around w-full h-full">

                    <!-- <b-tooltip :label="'editar'" position="is-right" v-if="withEditor && showPdfEditor">
                      <div class="w-8 h-8 overflow-hidden" @click="openEditor(props.row)">
                        <b-icon pack="fas" icon="pen" />
                      </div>
                    </b-tooltip> -->
                    <!-- <b-tooltip :label="$t('pictogram_statuses')" position="is-left">
                        <div @click="onShowInfoPictogramClicked(props.row)"
                            class="flex cursor-pointer text-sky-300">
                          <b-icon pack="fas" icon="info-circle"/>
                        </div>
                    </b-tooltip> -->

                    <b-tooltip v-if="allowedAction('config_statuses')"
                      :label="$t('configure')" position="is-left">
                        <div @click="onShowConfigurePictogramClicked(props.row)"
                            class="flex cursor-pointer text-sky-300">
                          <b-icon pack="fas" icon="cog"/>
                        </div>
                    </b-tooltip>

                    <!-- <b-tooltip v-if="allowedAction('config_statuses')"
                      :label="$t('pictogram_statuses')" position="is-left">
                        <div @click="onShowConfigStatusesPictogramClicked(props.row)"
                            class="flex cursor-pointer text-sky-300">
                          <b-icon pack="fas" icon="traffic-light"/>
                        </div>
                    </b-tooltip> -->


                    <b-tooltip v-if="allowedAction('visualize')"
                      :label="$t('view_document')" position="is-left">
                        <div @click="onShowViewerPictogramClicked(props.row)"
                            class="flex cursor-pointer text-sky-300">
                          <b-icon pack="fas" icon="eye"/>
                        </div>
                    </b-tooltip>

                    <!-- <b-tooltip v-if="allowedAction('link')"
                      :label="$t('view_assignments')" position="is-left">
                          <div @click="onShowLinkedActivities(props.row)"
                              class="flex cursor-pointer text-sky-300">
                            <b-icon pack="fas" icon="link"/>
                          </div>
                      </b-tooltip> -->

                      <b-tooltip v-if="allowedAction('visualize')"
                        :label="$t('move_up')" position="is-left">
                        <div @click="moveUp(props.row)"
                              class="flex cursor-pointer">
                          <b-icon icon="arrow-up" pack="fas"/>
                        </div>
                      </b-tooltip>

                    <b-tooltip v-if="allowedAction('visualize')"
                      :label="$t('move_down')" position="is-left">
                      <div @click="moveDown(props.row)"
                        class="flex cursor-pointer">
                        <b-icon icon="arrow-down" pack="fas"/>
                      </div>
                    </b-tooltip>

                    <b-tooltip v-if="allowedAction('delete')"
                      :label="$t('delete')" position="is-left" type="is-danger">
                        <div @click="removePictogram(props.row)"
                            class="flex cursor-pointer text-red">
                          <b-icon pack="fas" icon="trash-alt"/>
                        </div>
                    </b-tooltip>

                  </div>
                </template>
              </b-table-column>
            </template>

            <template slot="bottom-left">
                <b-icon pack="fas" class="flex text-blue" icon="folder"></b-icon>
                <b>{{ $t("total") }}</b>: {{ this.pictograms.length }}
            </template>

            <template #empty>
                <div class="has-text-centered">{{ $t('no_results') }}</div>
            </template>

          </b-table>
        </section>
        </div>
      </div>
    </div>

    </transition>
  </div>
</template>

<script>
import Form from "vform";
import axios from "axios";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";

export default {
  name: "pictograms-list",

  components: {
    ScaleLoader,
  },

  props: {
    entityId: { type: Number, required: true },
    disabledMenuActions: { type: Boolean, default: false },
    returnSelected: { type: Boolean, default: false },
    showDownloadFileOriginal: { type: Boolean, default: true }, // para mostar o no la columna de descarga de fichero original (en futuro tal vez no sea necesario)
    permittedActions: { type:Object, default() { return {} } } // acciones que se mostraran en la columna acciones por defecto todas
  },

  data() {
      return {
      isLoading: true,
      page: 1,
      perPage: 25,
      total: 0,
      orderField: "reference_code",
      orderDir: "asc",
      currentPage: 1,
      defaultSortDirection: 'asc',
      isPaginationSimple: false,
      isPaginated: true,

      pictograms: [],
      checkedRows: [],
      highlightedRowId: null,
    }
  },

  mounted() {
    this.getProjectPictograms();
  },

  methods: {
    async getProjectPictograms() {
      this.isLoading = true;
      let params = {
        with_screenshot: 1,
        with_associated_activity: 1,
        light: 1, // listado (tabla): no usa capas/estados → modo ligero
      };

      const { data } = await axios.get(
        "/api/v2/project/" + this.entityId + "/pictograms",
        { params: params }
      );

      if (data && data.success) {
        this.pictograms = data.pictograms;
        this.total = data.pictograms ? data.pictograms.length : 0;
      } else {
        this.$notify.error("error_loading_documents");
      }
      this.isLoading = false;
    },

    reload() {
      this.getProjectPictograms();
    },

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    reloadActivities() {
      this.reload()
    },

    async removePictogram(row) {
      this.$dialog.confirm({
        title: this.$t("delete"),
        message: this.$t("delete_generic", [row.name]),
        confirmText: this.$t("delete"),
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          // this.documentId = null

          this.isLoading = true;
          // let url = "/api/v2/project/" + this.projectId + '/document/' + row.document_id;
          let url = "/api/v2/pictogram/" + row.id + '/delete/';
          const { data } = await axios.post(url);

          if (data.success) {
            this.$toast.open({
              message: this.$t("success_deleting_generic"),
              type: "is-success",
              position: "is-top-right"
            });
            await this.sleep(1000);
            this.reload();
          } else {
            this.isLoading = false;
            // Error
            this.$toast.open({
              message: data.error || this.$t("error_saving"),
              type: "is-danger",
              position: "is-top-right"
            });
          }
        }
      });
    },

    onShowViewerPictogramClicked(row) {
      this.$emit('epc-preview', row)
    },

    onShowConfigurePictogramClicked(row) {
      this.$emit('epc-configure-pictogram', row)
    },

    onShowConfigStatusesPictogramClicked(row) {
      this.$emit('epc-openstatuses', row)
    },


    onShowLinkedActivities(row) {
      this.$emit('epc-openlinked', row)
    },

    handleCheck(checkedList, row) {
      let pictogramsId = checkedList.map((item) => { return item.id })
      this.$emit('epc-openlink', pictogramsId)
    },

    onShowInfoPictogramClicked(row) {
      this.$emit('epc-openinfo', row)
    },

    allowedAction(action) {
      if (Object.keys(this.permittedActions).length === 0)
        return true;

      return this.permittedActions[action] === 'undefined' ? false : this.permittedActions[action]
    },

    async moveUp(row) {
      const index = this.pictograms.indexOf(row);
      if (index <= 0) return;

      // 1. Guardamos el estado original por si hay que revertir
      const originalList = [...this.pictograms];

      // 2. Realizamos el swap local (Optimista)
      const neighbor = this.pictograms[index - 1];
      const tempOrder = row.order_column;
      row.order_column = neighbor.order_column;
      neighbor.order_column = tempOrder;
      this.$set(this.pictograms, index - 1, row);
      this.$set(this.pictograms, index, neighbor);
      this._highlightRow(row.id);

      try {
        // 3. Llamada al API en segundo plano
        const { data } = await axios.post(`/api/v2/pictogram/${row.id}/reorder`, { direction: 'up' });
        if (!data.success) throw new Error();
      } catch (error) {
        // 4. Si falla, revertimos al estado anterior
        this.pictograms = originalList;
        this.$toast.open({
          message: this.$t("error_reordering"),
          type: "is-danger"
        });
      }
    },

    async moveDown(row) {
      const index = this.pictograms.indexOf(row);
      if (index >= this.pictograms.length - 1) return;

      const originalList = [...this.pictograms];

      // Realizamos el swap local
      const neighbor = this.pictograms[index + 1];
      const tempOrder = row.order_column;
      row.order_column = neighbor.order_column;
      neighbor.order_column = tempOrder;
      this.$set(this.pictograms, index + 1, row);
      this.$set(this.pictograms, index, neighbor);
      this._highlightRow(row.id);

      try {
        const { data } = await axios.post(`/api/v2/pictogram/${row.id}/reorder`, { direction: 'down' });
        if (!data.success) throw new Error();
      } catch (error) {
        this.pictograms = originalList;
        this.$toast.open({
          message: this.$t("error_reordering"),
          type: "is-danger"
        });
      }
    },

    _highlightRow(rowId) {
      this.highlightedRowId = rowId;
      clearTimeout(this._highlightTimer);
      this._highlightTimer = setTimeout(() => {
        this.highlightedRowId = null;
      }, 1500);
    },
  }
}
</script>

<style scoped>
:deep(.row-highlight) {
  animation: highlight-fade 1.5s ease-out;
}

@keyframes highlight-fade {
  0% {
    background-color: rgba(59, 130, 246, 0.25);
  }
  100% {
    background-color: transparent;
  }
}

.pictogram-preview {
  width: 100px;
  height: 64px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
  background-color: #f8fafc;
}
</style>
